import React from 'react';
import { Application } from '../../../models';
import { PersonIcon } from '../../icons';
import ContactForm from './ContactForm';

interface ThirdStepProps {
  application?: Application;
  isReadOnly?: boolean;
}

export default function ThirdStep({
  application = null,
  isReadOnly = false,
}: ThirdStepProps) {
  return (
    <div className="p-6 lg:py-20 lg:px-32 flex flex-col">
      <div className="w-20 h-20 rounded-full bg-[#FFE5C8] border border-[#FFD6A8] flex">
        <PersonIcon className="h-12 w-12 m-auto text-orange" />
      </div>
      <div className="mt-8">
        <h2 className="font-bold text-5xl text-neutral-600">
          Contact Information
        </h2>
      </div>
      <div className="mt-8 flex flex-col">
        <ContactForm
          application={application}
          applicant={application?.applicant}
          isReadOnly={isReadOnly}
        />
      </div>
    </div>
  );
}
